/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicInventoryUnitRate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicInventoryUnitRate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicInventoryUnitRate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicInventoryUnitRate>): BackgroundJobPayloadForPeriodicInventoryUnitRate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicInventoryUnitRate(), model);
        BackgroundJobPayloadForPeriodicInventoryUnitRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicInventoryUnitRate>): BackgroundJobPayloadForPeriodicInventoryUnitRate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicInventoryUnitRate.newInstance(<BackgroundJobPayloadForPeriodicInventoryUnitRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicInventoryUnitRate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicInventoryUnitRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicInventoryUnitRate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicInventoryUnitRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
